import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import GoBackBar from '@trdk/style/GoBackBar';
import Divider from '@material-ui/core/Divider';
import { useHistory, useLocation } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  root: {
    flex: '1 0 0',
    flexDirection: 'row',
    padding: '0 1.6rem',
    minWidth: '20rem',
    marginLeft: 'calc(100vw - 100%)',
    marginBottom: '8rem',
  },
  wrapper: {
    maxWidth: '68.5rem',
    margin: 'auto',
  },
}));

const PageContainer = ({ children }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const history = useHistory();

  function handleClick() {
    const path = history.location.pathname.split('/');
    const s = path.slice(0, path.length - 1).join('/');
    history.replace(s);
  }

  return (
    <>
      <GoBackBar isHidden={pathname === '/'} handleClick={handleClick} />
      <Divider />
      <div className={classes.root}>
        <div className={classes.wrapper}>{children}</div>
      </div>
    </>
  );
};

PageContainer.propTypes = {
  children: PropTypes.any.isRequired,
};

export default PageContainer;
